<template>
<div class="chapter">
<div class="inner_page">
<h2 class="halftl"><a id="page_xi">ETHNOGRAPHIC ENCOUNTERS <span class="small">IN</span> ISRAEL</a></h2><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_half.vue?564da89a